import {AxiosResponse } from 'axios';

import apiClient from './client';
import { ApiResponseDto } from 'interfaces/apiResponse';
import { AcquisitionSource, CreateAcquisitionSource, UpdateAcquisitionSource } from 'interfaces/acquisition_source';

interface AcquisitionSourceService {
  getAcquisitionSources(queryParams?: any): Promise<AcquisitionSource[]>
  createAcquisitionSource(postData: any): Promise<AxiosResponse<any>>
  editAcquisitionSource(id: number, postData: any): Promise<AxiosResponse<any>>
  deleteAcquisitionSource(id: number): Promise<AxiosResponse<any>>
}

const endpoints = {
  getAcquisitions: '/acquisition-sources',
  createAcquisitionSource: '/acquisition-sources',
  editAcquisitionSource: (id: number) => `/acquisition-sources/${id}`,
  deleteAcquisitionSource: (id: number) => `/acquisition-sources/${id}`,
}

export const acquisitionSourceService: AcquisitionSourceService = {
  getAcquisitionSources: async (queryParams?: any): Promise<AcquisitionSource[]> => {
    const response: AxiosResponse<ApiResponseDto<AcquisitionSource[]>> = await apiClient.get(endpoints.getAcquisitions, {params: {...queryParams}});

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
  createAcquisitionSource: async (postData: CreateAcquisitionSource): Promise<AxiosResponse<any>> => {
    return apiClient.post(endpoints.createAcquisitionSource, postData);
  },
  editAcquisitionSource: async (id: number, postData: UpdateAcquisitionSource): Promise<AxiosResponse<any>> => {
    return apiClient.put(endpoints.editAcquisitionSource(id), postData);
  },
  deleteAcquisitionSource: async (id: number): Promise<AxiosResponse<any>> => {
    return apiClient.delete(endpoints.deleteAcquisitionSource(id));
  }
}
